export default __webpack_public_path__ + "static/media/26.f6e4a65b.jpg";